import LocationEdit from './LocationEdit';

export default {
  edit: LocationEdit,
};
